import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { id: "app-container" }
const _hoisted_2 = {
  key: 0,
  class: "public-layout"
}
const _hoisted_3 = {
  key: 1,
  class: "dashboard-layout"
}
const _hoisted_4 = { class: "main-content" }
const _hoisted_5 = { class: "dashboard-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_main_page = _resolveComponent("the-main-page")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_the_modern_footer = _resolveComponent("the-modern-footer")!
  const _component_the_sidebar = _resolveComponent("the-sidebar")!
  const _component_toast_notification = _resolveComponent("toast-notification")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isLoggedIn)
      ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
          _createElementVNode("header", null, [
            _createVNode(_component_the_main_page)
          ]),
          _createElementVNode("main", null, [
            _createVNode(_component_router_view)
          ]),
          _createElementVNode("footer", null, [
            _createVNode(_component_the_modern_footer)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_the_sidebar),
          _createElementVNode("div", {
            class: _normalizeClass(["dashboard-content", { 'sidebar-collapsed': _ctx.sidebarCollapsed }])
          }, [
            _createElementVNode("main", _hoisted_4, [
              _createVNode(_component_router_view)
            ]),
            _createElementVNode("footer", _hoisted_5, [
              _createVNode(_component_the_modern_footer)
            ])
          ], 2)
        ])),
    _createVNode(_component_toast_notification)
  ]))
}